// Dashboard.js
import React, { useEffect } from "react";
import Layout from "./Layout";
import Home from "../components/Home/Home";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice.js";

import Content from "../ui/Content";
import Profile from "../components/Profile/Profile";
import Stats from "../components/Stats/Stats";
import Team from "../components/Team/Team";
import Event from "../components/Event/Event";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError && !user) {
      navigate("/");
    }
  }, [isError, user, navigate]);

  return (
    <>
      <Layout>
        {/* <Home /> */}
        <Content>
          <Stats />

          <div className="flex flex-col gap-3 lg:flex-row">
            {/* <Team /> */}
            <Event />
          </div>
        </Content>
        <Profile />
      </Layout>
    </>
  );
};

export default Dashboard;
